import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DataExport from "./DataExport";
import Import from "./Import";
import CommentsExport from "./CommentsExport";
import PdfExport from "./PdfExport";
import { setImportCurrentView } from "../Survey/Survey.slice";
import { USER_ROLES } from "../../Utility/constants";
import DataFilters from "./DataFilters";
import PanelImport from "../FileMgr/PanelImport";
import Button from "../../components/Common/Button";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function FileMgr() {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(0);

  const visitDataFilterRule = location?.state?.visitDataFilterRule;
  const visitPanelImport = location?.state?.visitPanelImport;
  const surveyId = location?.state?.surveyId;
  const surveyName = location?.state?.surveyName;
  const surveyPanelId = location?.state?.surveyPanelId;
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setImportCurrentView(1));
  };

  const roleName = useSelector(
    (state) => state?.survey?.loggedInUserData?.authorizedUser?.role?.name
  );
  const isAccessAllowed =
    roleName === USER_ROLES.BUILDER_SUPER_USER_ROLENAME ||
    roleName === USER_ROLES.BUILDER_ADMIN_ROLENAME;

  useEffect(() => {
    const redirectDataFilters = () => {
      setValue(3);
      dispatch(setImportCurrentView(3));
    };
    if (visitDataFilterRule) {
      redirectDataFilters();
    } else if (visitPanelImport) {
      setValue(4);
      dispatch(setImportCurrentView(1));
    }
  }, [visitDataFilterRule, visitPanelImport]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {visitPanelImport && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              navigate("/panel-mgr", {
                state: {
                  surveyId: surveyId,
                  surveyName: surveyName,
                  surveyPanelId: surveyPanelId,
                  visitPanelImport: true,
                },
              })
            }
          >
            Back to panel manager
          </Button>
        </Box>
      )}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{
            "& button": { borderRadius: "10px 10px 0 0" },
            "& button:hover": { backgroundColor: "rgba(0, 48, 135, 0.05)" },
            "& button.Mui-selected": {
              backgroundColor: "rgba(0, 48, 135, 0.15)",
              color: "#003087",
            },
          }}
        >
          <Tab
            sx={{ color: "#003087" }}
            label="Data Export"
            {...a11yProps(0)}
          />
          <Tab
            sx={{ color: "#003087" }}
            label="COMMENTS EXPORT"
            {...a11yProps(1)}
          />
          <Tab
              sx={{ color: "#003087" }}
              label="PDF EXPORT"
              {...a11yProps(1)}
          />
          {isAccessAllowed && (
            <Tab
              sx={{ color: "#003087" }}
              label="Data Import"
              {...a11yProps(2)}
            />
          )}
          <Tab
            sx={{ color: "#003087" }}
            label="PANEL IMPORT"
            {...a11yProps(4)}
          />
          {isAccessAllowed && (
              <Tab
                  sx={{ color: "#003087" }}
                  label="DATA FILTERS"
                  {...a11yProps(3)}
              />
          )}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <DataExport />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <CommentsExport />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <PdfExport />
      </CustomTabPanel>
      {isAccessAllowed && (
        <CustomTabPanel value={value} index={3}>
          <Import />
        </CustomTabPanel>
      )}
      <CustomTabPanel value={value} index={4}>
        <PanelImport />
      </CustomTabPanel>
      {isAccessAllowed && (
          <CustomTabPanel value={value} index={5}>
            <DataFilters />
          </CustomTabPanel>
      )}
    </Box>
  );
}
